import { useState } from 'react';

interface Props {
  error: string;
  isDark: boolean;
  compact?: boolean;
}

export default function EsmsErrorBox({ error, isDark, compact = false }: Props) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(error);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // fallback
      const ta = document.createElement('textarea');
      ta.value = error;
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); setCopied(true); setTimeout(() => setCopied(false), 1500); } catch {}
      document.body.removeChild(ta);
    }
  };

  const baseCls = isDark
    ? 'bg-red-500/10 border border-red-500/30 text-red-300'
    : 'bg-red-50 border border-red-200 text-red-700';

  return (
    <div className={`rounded-lg ${compact ? 'p-2 text-xs' : 'p-3 text-sm'} ${baseCls} relative group`}>
      <div className="flex items-start gap-2">
        <div className="flex-1 whitespace-pre-wrap break-words font-mono">{error}</div>
        <button
          onClick={copy}
          title={copied ? 'Đã copy' : 'Copy log'}
          className={`shrink-0 px-2 py-1 rounded text-xs ${isDark ? 'bg-white/10 hover:bg-white/20 text-slate-200' : 'bg-white hover:bg-gray-100 border border-gray-300 text-gray-700'}`}
        >
          {copied ? '✓ Copied' : '📋 Copy'}
        </button>
      </div>
    </div>
  );
}
